import {AxiosResponse} from 'axios'
import {HttpInstance} from '../createHttpInstance'
import {
  GetRecognitionAttemptsRequest,
  RawPhotoRecognitionAttempts,
} from './types'

export interface GetRecognitionAttempts<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const getRecognitionAttempts: GetRecognitionAttempts<
  GetRecognitionAttemptsRequest,
  RawPhotoRecognitionAttempts
> = (http, params) => {
  const {PhotoID, ClientID, AllScans} = params

  const queryParams: string[] = []
  queryParams.push(`clientid=${ClientID}`)
  // Only append allscans when explicitly requested — the default (latest scan)
  // path must send no allscans param at all.
  if (AllScans) {
    queryParams.push('allscans=true')
  }
  const query = `?${queryParams.join('&')}`

  const path = `/v2/faces/photos/${PhotoID}/recognition-attempts`

  return http.request<RawPhotoRecognitionAttempts>({
    method: 'GET',
    url: `${path}${query}`,
  })
}
